<template>
	<div class="shipment-search">
		<div class="container py-3">
			<!-- Headers -->
			<div class="page-header">
				<h3 class="page-title">{{titlePage}}</h3>
				<div class="d-flex justify-content-between mt-4">
					<filter-product
						@set-filter-product="setFilterProduct"
						@apply="applyFilterProducts"
						@select-products="onSelectedProduct"
						@product-search="onProductSearch"
					/>
					<daterangepicker
						:presets="filterDatePresets"
						:start="since"
						:end="until"
						@selected="setFilterDate"
						ref="datePicker"
					>
					</daterangepicker>
				</div>
			</div>

			<div class="summaries">
				<div class="row">
					<div v-for="(summary, index) in generalSummaries" :key="index" class="col-12 col-sm-3">
						<Overview
							v-if="isTeamMemberHasAccess(summary.rule_name)"
							:icon="summary.icon"
							icon-type="uicons"
							type="normal"
							size="normal"
							:text="summary.title"
							:is-fetching="isSummaryFetching"
							:number="summary.value"
							:info="summary.tooltip"
							:clickable="summary.key_filter === 'all'"
							:class="{'active': status === summary.key_filter}"
							@click="onOverviewAction(summary.key_filter)">
						</Overview>
					</div>
				</div>
				<div class="row">
					<div
						v-for="summary in visibleSummaries"
						:key="summary.key"
						class="col-12 col-sm-3">
						<Overview
							v-if="isTeamMemberHasAccess(summary.rule_name)"
							:number="summary.value"
							:icon="summary.icon"
							:text="summary.label"
							:icon-type="'uicons'"
							:is-fetching="isSummaryFetching"
							:type="'normal'"
							:size="'normal'"
							:clickable="true"
							:info="summary.tooltip"
							:class="{'active': status === summary.key_filter}"
							@click="onOverviewAction(summary.key_filter)">
						</Overview>
					</div>
				</div>
			</div>

			<div class="d-flex justify-content-between my-2">
				<!-- Export -->
				<div class="d-flex align-items-center">
					<router-link
						v-if="isDropshipper"
						to="/wholesale-order/import"
						class="btn btn-success px-3 mr-2">
						{{ $t("Import") }}
					</router-link>

					<button
						type="button"
						class="btn btn-light px-3"
						:class="{ 'is-loading': isExportLoading }"
						data-toggle="dropdown"
						data-display="static"
						aria-haspopup="true"
						aria-expanded="false"
						@click="exportData">
						{{ $t("Export") }}
					</button>

					<!-- Process order for seller -->
					<button
						v-if="isDropshipper"
						class="btn btn-info ml-2"
						:disabled="selectedData.length === 0"
						@click="processOrder">
						Process Order
					</button>

					<!-- Process order for supplier -->
					<div
						v-if="!isDropshipper"
						class="dropdown">
						<button
							type="button"
							class="btn btn-info dropdown-toggle ml-2"
							data-toggle="dropdown"
							data-display="static"
							aria-haspopup="true"
							aria-expanded="false"
							:disabled="selectedData.length === 0 || isUpdatingStatusBulk"
						>
							Action
						</button>

						<div class="dropdown-menu table-action-dropdown">
							<button
								type="button"
								class="dropdown-item"
								:disabled="selectedData.length === 0 || isUpdatingStatusBulk"
								@click="updateStatus('processing')"
							>
								Process
							</button>
							<button
								type="button"
								class="dropdown-item"
								:disabled="selectedData.length === 0 || isUpdatingStatusBulk"
								@click="updateStatus('completed')"
							>
								Completed
							</button>
							<button
								type="button"
								class="dropdown-item"
								:disabled="selectedData.length === 0 || isUpdatingStatusBulk"
								@click="updateStatus('cancelled')"
							>
								Cancelled
							</button>
							<button
								type="button"
								class="dropdown-item"
								:disabled="selectedData.length === 0"
								@click="printShippingLabels"
							>
								Print Shipping Label
							</button>
						</div>
					</div>

					<div v-if="selectedData.length > 0" class="ml-3">
						{{ selectedData.length }} Wholesale Order select
					</div>

				</div>

				<!-- Option -->
				<div class="d-flex align-items-end" style="width: 25%;">
					<select v-model="orderType" class="form-select form-control" aria-label="Default select example">
						<option selected value="all">All</option>
						<option v-for="(type, index) in optionOrderType" :key="index" :value="type.key">{{ type.label }}</option>
					</select>
					<input
						style="height: 38px;"
						type="text"
						class="input form-control form-control-sm"
						placeholder="Search Wholesale Order"
						v-focus
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>

			<!-- Filters -->
			<div v-if="isAdmin" class="d-flex align-items-center my-2">
				<input
					type="text"
					class="form-control form-control-sm mr-2"
					style="max-width: 250px;"
					placeholder="Filter by Supplier (name, ID, email)"
					v-model="supplierFilter"
					@input="onSupplierFilterChange"
				/>
				<input
					type="text"
					class="form-control form-control-sm"
					style="max-width: 250px;"
					placeholder="Filter by Seller Email"
					v-model="sellerFilter"
					@input="onSellerFilterChange"
				/>
			</div>
			<!-- Table -->
			<!-- <PrivateOrderTable
				v-if="isTeamMemberHasAccess('wholesale_list_order')"
				:is-loading="isFetching"
				:type="type"
				:show-modal-process-order="showModalProcessOrder"
				@close-modal-process-order="showModalProcessOrder = false"
				@trigger-summary="getMonitoringStats"
				@trigger-fetch-data="fetchData"
			/> -->
			<PrivateOrderTableNew
				ref="privateOrderTable"
				v-if="isTeamMemberHasAccess('wholesale_list_order')"
				:is-loading="isFetching"
				:type="type"
				:show-modal-process-order="showModalProcessOrder"
				@close-modal-process-order="showModalProcessOrder = false"
				@trigger-summary="getMonitoringStats"
				@trigger-fetch-data="fetchData"
			/>
		</div>

		<!-- Modal -->
		<modal
			class="update-status-modal"
			size="small"
			v-if="isShowModalUpdateStatus"
			@close="isShowModalUpdateStatus = false">
			<template slot="header">
				<h3>Update Status</h3>
			</template>
			<template slot="body">
				<p>{{ $t('Are you sure want to update ') }} {{ selectedData.length }} {{ $t('orders') }},
					to <b class="text-capitalize">{{ selectedUpdateStatus }}</b> ?
				</p>
			</template>
			<template slot="footer">
				<!-- Cancel -->
				<button
					type="button"
					class="btn btn-light"
					@click="isShowModalUpdateStatus = false">
					{{ $t('No') }}
				</button>
				<!-- Submit -->
				<button
					class="btn btn-success"
					:class="{ 'is-loading': isUpdatingStatusBulk }"
					@click="doUpdateStatusBulk">
					<span>{{ $t('Yes') }}</span>
				</button>
			</template>
		</modal>

	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import FilterProduct from '@/components/FilterProduct.vue';
import Daterangepicker from '@/components/Daterangepicker.vue';
// import PrivateOrderTable from '@/components/private-orders/Table.vue';
import Modal from '@/components/Modal.vue';
import PrivateOrderTableNew from '@/components/private-orders/NewTable.vue';
import Overview from '@/components/Overview.vue';
import {
	exportDataAdmin,
	exportDataOwner,
	getAdminMonitoring,
	getMonitoringOrder,
	getDataStasts,
	updateStatusBulk,
} from '@/api/private-order';
import { downloadFile, duplicateVar } from '@/lib/helper';

export default {
	name: 'PrivateOrders',
	components: {
		FilterProduct,
		Daterangepicker,
		// PrivateOrderTable,
		PrivateOrderTableNew,
		Overview,
		Modal,
	},
	props: {
		type: {
			type: String,
			default: () => 'admin',
		},
	},
	data() {
		return {
			since: null,
			until: null,
			isSummaryFetching: false,
			overviewItems: {
				primary: [
					'submission_count',
					'shipping_pending',
					'shipping_processed',
					'shipping_delivery',
					'shipping_completed',
				],
			},
			summaryGeneral: [
				{
					title: 'Total Pesanan',
					key: 'submission_count',
					icon: 'shopping-cart',
					rule_name: 'wholesale_scoreboard_total_order',
					key_filter: 'all',
					value: 0,
					tooltip: 'Total Pesanan Wholesale Order',
				},
			],
			selectAll: [],
			summaries: [
				{
					key: 'shipping_pending',
					key_filter: 'pending',
					icon: 'hourglass-end',
					label: 'Perlu Diproses',
					rule_name: 'wholesale_scoreboard_pending',
					value: 0,
					tooltip: '',
				},
				{
					key: 'shipping_processed',
					key_filter: 'processing',
					icon: 'truck-loading',
					rule_name: 'wholesale_scoreboard_processing',
					label: 'Sedang Diproses',
					value: 0,
					tooltip: '',
				},
				// {
				// 	key: 'shipping_delivery',
				// 	key_filter: 'delivery',
				// 	icon: 'rocket-lunch',
				// 	rule_name: 'wholesale_scoreboard_delivery',
				// 	label: 'Dalam Pengiriman',
				// 	value: 0,
				// 	tooltip: '',
				// },
				{
					key: 'order_completed',
					key_filter: 'completed',
					icon: 'check',
					rule_name: 'wholesale_scoreboard_delivered',
					label: 'Dikirim',
					value: 0,
					tooltip: '',
				},
				{
					key: 'order_cancelled',
					key_filter: 'cancelled',
					icon: 'cross',
					rule_name: 'wholesale_scoreboard_cancelled',
					label: 'Dibatalkan',
					value: 0,
					tooltip: '',
				},
			],
			optionOrderType: [
				{
					label: 'Bulky',
					key: 'bulky',
				},
				{
					label: 'Outsource',
					key: 'outsource',
				},
			],
			orderType: 'all',
			isFetching: false,
			isExportLoading: false,
			isAll: false,
			filterProducts: '',
			keyword: '',
			supplierFilter: '',
			sellerFilter: '',
			page: 1,
			status: 'all',
			limit: 10,
			showModalProcessOrder: false,
			isShowModalUpdateStatus: false,
			isUpdatingStatusBulk: false,
			selectedUpdateStatus: 'pending',
		};
	},
	computed: {
		...mapGetters({
			filterDatePresets: 'filterDatePresets',
			overview: 'overview',
			user: 'user',
			isAdmin: 'isAdmin',
			isOwner: 'isOwner',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			selectedData: 'monitoringPrivateOrder/selectedData',
			privateOrders: 'monitoringPrivateOrder/privateOrders',
			isUserCan: 'isUserCan',
		}),
		titlePage() {
			let title = 'Orders';
			if (this.type === 'admin') title = 'Monitoring Wholesale Order';
			else if (this.isSupplier) title = 'Wholesale Order';
			return title;
		},
		querySince() {
			return this.$route?.query?.since;
		},
		queryUntil() {
			return this.$route?.query?.until;
		},
		queryType() {
			return this?.$route?.query?.type;
		},
		queryOrderType() {
			return this?.$route?.query?.order_type;
		},
		getParams() {
			const params = {
				page: this.page,
				limit: this.limit,
			};

			if (this.since) {
				params.since = this.since;
			}

			if (this.until) {
				params.until = this.until;
			}

			if (this.filterProducts && (this.filterProducts !== '[]') && this.filterProducts !== null) {
				params.filter_product = this.filterProducts;
			}

			if (this.keyword) {
				params.keyword = this.keyword;
			}

			if (this.supplierFilter) {
				params.supplier_filter = this.supplierFilter;
			}

			if (this.sellerFilter) {
				params.seller_filter = this.sellerFilter;
			}

			if (this.status && this.status !== 'all') {
				params.status = this.status;
			}

			if (this.orderType !== 'all') {
				params.order_type = this.orderType;
			}

			return params;
		},
		currentPageType() {
			let type = this.type;

			if (!this.type && this.type === '') {
				type = 'admin';
			}

			return type;
		},
		generalSummaries() {
			const summaries = this.summaryGeneral;
			if (this.type === 'admin' || this.type === 'supplier') {
				summaries.push({
					title: 'Total Quantity Delivered',
					key: 'quantity',
					icon: 'truck-side',
					key_filter: 'quantity',
					rule_name: 'wholesale_scoreboard_total_quantity_and_delivered',
					value: 0,
					tooltip: 'Total Quantity yang telah berhasil di kirim',
				});
			}
			return summaries;
		},
		visibleSummaries() {
			let summaries = this.summaries;
			if (this.type === 'supplier') {
				// Remove pending scoreboard
				summaries = summaries.filter(s => s.key !== 'shipping_pending');
			}
			return summaries;
		},
	},
	watch: {
		orderType(value) {
			if (value) {
				this.fetchData(true);
				this.$router.push({ query: { ...this.$route.query, order_type: value } });
			}
		},
		'$route.query.q': function (value) {
			if (value) {
				this.initFilter();
				this.fetchData(true);
			}
		},
	},
	created() {
		this.initFilter();
		this.fetchData(true);


		window.addEventListener('scroll', this.handleScroll);
	},
	methods: {
		...mapActions({
			setData: 'monitoringPrivateOrder/setData',
			setScoreboard: 'monitoringPrivateOrder/setScoreboard',
			setAllData: 'monitoringPrivateOrder/setAllData',
			concatData: 'monitoringPrivateOrder/concatData',
		}),
		setFilterProduct() {},
		onSelectedProduct(product) {
			console.log('halo priduct -> ', product);
		},
		fetchData(isReset = true) {
			this.getDataMonitoring(isReset);
			this.getMonitoringStats();
		},
		applyFilterProducts(product) {
			this.filterProducts = JSON.stringify(product);
			this.fetchData(true);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 100;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.page++;
					this.fetchData(false);
				}
			}
		},
		resetItems() {
			this.isAll = false;
			this.page = 1;
			this.setData([]);
		},
		setVerticalScroll() {
			const ordersList = document.getElementById('orders-list');
			if (ordersList) {
				const ordersListTable = document.getElementById('orders-list-table');
				const ordersListVerticalScroll = document.getElementById(
					'orders-list-vertical-scroll',
				);
				const ordersListVerticalScrollContent = document.getElementById(
					'orders-list-vertical-scroll-content',
				);
				const listWidth = ordersList.offsetWidth;
				const listLeft = ordersList.offsetLeft;
				const tableWidth = ordersListTable.offsetWidth;
				ordersListVerticalScroll.style.width = `${listWidth}px`;
				ordersListVerticalScroll.style.left = `${listLeft}px`;
				ordersListVerticalScrollContent.style.width = `${tableWidth}px`;
			}
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const since = dayjs(filterDate.start).format('YYYY-MM-DD');
			const until = dayjs(filterDate.end).format('YYYY-MM-DD');
			this.since = since;
			this.until = until;
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			this.fetchData(true);
		},
		overviewAction() {},
		initFilter() {
			if (this.querySince) {
				this.since = this.querySince;
			}

			if (this.queryUntil) {
				this.until = this.queryUntil;
			}

			if (this.queryOrderType) {
				this.orderType = this.queryOrderType;
			} else {
				this.orderType = 'all';
			}

			if (this.queryType) {
				this.status = this.queryType;
			} else {
				this.status = 'all';
			}

			if (this.$route.query.q) {
				this.keyword = this.$route.query.q;
			} else {
				this.keyword = '';
			}
		},
		getDataMonitoring(isReset = false) {
			if (isReset) {
				this.resetItems();
			}
			const params = this.getParams;
			this.isFetching = true;
			const callback = (res) => {
				const data = res?.data?.data;

				this.isFetching = false;
				this.datas = data || [];
				// console.log('this.datas: ', this.datas);

				if (this.datas.length > 0 && !this.isAll) {
					this.concatData(this.datas);
				} else {
					this.isAll = true;
				}
			};
			const err = e => console.log(e);

			if (this.type === 'admin') {
				getAdminMonitoring(params, callback, err);
			} else {
				getMonitoringOrder(params, callback, err);
			}
		},
		getMonitoringStats() {
			this.isSummaryFetching = true;
			const params = this.getParams;
			const callback = (res) => {
				const data = res?.data?.data;
				this.isSummaryFetching = false;
				this.generalSummaries.map((curr) => {
					curr.value = data[curr.key];

					return curr;
				});

				this.summaries.map((curr) => {
					curr.value = data[curr.key];

					return curr;
				});
			};
			const err = e => console.log(e);

			getDataStasts(params, callback, err);
		},
		exportData() {
			const params = this.getParams;
			this.isExportLoading = true;
			const callback = (res) => {
				const url = res?.data?.data;
				downloadFile(url);
				this.isExportLoading = false;
			};
			const err = e => console.log(e);
			if (this.type === 'admin') {
				exportDataAdmin(params, callback, err);
			} else {
				exportDataOwner(params, callback, err);
			}
		},
		onKeywordChange() {
			const self = this;
			this.ooDelay(() => {
				const keyword = this.keyword ? this.keyword.trim() : '';
				const query = duplicateVar(this.$route.query);
				if (keyword !== '') {
					query.q = keyword;
				} else {
					delete query.q;
				}
				const params = { query };
				this.$router.push(params);
				// reset
				if (!keyword || keyword === '' || keyword === null) {
					self.fetchData(true);
				}
			}, 1000);
		},
		onSupplierFilterChange() {
			const self = this;
			this.ooDelay(() => {
				self.fetchData(true);
			}, 800);
		},
		onSellerFilterChange() {
			const self = this;
			this.ooDelay(() => {
				self.fetchData(true);
			}, 800);
		},
		onOverviewAction(key) {
			this.status = key ?? '';
			if (this.status !== 'quantity') {
				this.fetchData(true);
			}

			this.$router.push({ query: { ...this.$route.query, type: this.status } });
		},
		onProductSearch(productKeyword) {
			console.log(productKeyword);
		},
		isTeamMemberHasAccess(feature) {
			if ((!this.isOwner && !this.isAdmin) && feature) {
				return this.isUserCan(feature);
			}

			return true;
		},
		processOrder() {
			this.showModalProcessOrder = true;
		},
		updateStatus(params) {
			const status = params;
			this.selectedUpdateStatus = status;
			this.isShowModalUpdateStatus = true;
		},
		doUpdateStatusBulk() {
			const status = this.selectedUpdateStatus;
			this.isUpdatingStatusBulk = true;
			const params = {
				order_ids: this.selectedData,
				status,
			};

			const callback = () => {
				this.fetchData(true);

				this.isUpdatingStatusBulk = false;
				this.isShowModalUpdateStatus = false;
				this.setData([]);
				this.$notify({
					group: 'app',
					title: 'Wholesale Order',
					text: 'Process Order Successfully',
					type: 'success',
				});
			};
			const err = (e) => {
				console.log('e: ', e);
				console.log(e.response.data.message);
				this.$notify({
					group: 'app',
					title: 'Wholesale Order Update Status',
					text: e.response.data.message,
					type: 'error',
				});
				this.isUpdatingStatusBulk = false;
				this.isShowModalUpdateStatus = false;
			};

			updateStatusBulk(params, callback, err);
		},
		printShippingLabels() {
			if (this.$refs.privateOrderTable) {
				this.$refs.privateOrderTable.printMultipleShippingLabels();
			}
		},
	},
};
</script>

<style lang="scss" scoped>

.form-select {
	padding: 7px 12px;
	border-radius: 8px;
	border-color: #d9dee2;
	margin-right: 10px;
	font-size: 16px;
}

.table-vertical-scroll {
	display: none;
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	// width: 100%;
	overflow: auto;

	&::-webkit-scrollbar {
		-webkit-appearance: none;
		width: 11px;
	}

	&::-webkit-scrollbar-thumb {
		border-radius: 8px;
		background-color: rgba(0,0,0,.5);
		-webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
	}

	&::-webkit-scrollbar-track {
		background-color: rgba(0,0,0,.1);
	}
}

.table-vertical-scroll-content {
	height: 15px;
	background: transparent;
}

</style>
